import { useParams } from 'react-router-dom'
import { Box } from '@mantine/core'

import { Charts } from '@/modules/advisors/users/pages/[id]/components/Charts/Charts'
import { UserInfoHeader } from '@/modules/advisors/users/pages/[id]/components/UserInfoHeader/UserInfoHeader'

import { useAdvisorsServiceAdvisorUsersControllerGetUserById } from '@/__generated__/queries'

export function Component() {
  const { id: userId } = useParams<{ id: string }>()
  const numericUserId = userId ? +userId : 0

  const { data: user } = useAdvisorsServiceAdvisorUsersControllerGetUserById({
    userId: numericUserId,
  })

  if (!user) return null

  return (
    <Box>
      <UserInfoHeader user={user} userId={userId ?? ''} />

      <Charts userId={numericUserId} />
    </Box>
  )
}

Component.displayName = 'User'
